<template>
  <div class="add-partner" :class="{ 'not-inline': !isInline }">
    <div class="add-partner-container">
      <aside>
        <img src="@/assets/images/side-cover.jpg" alt="Add partner" />
      </aside>

      <Form
        :schema="schema"
        @submit="submit"
        :values="values"
        v-slot="{ errors, success }"
        class="form-wrap"
        :class="[{ 'is-loading': is_loading }, { 'is-error': is_error }]"
        :is_disabled="$store.state.is_loading || $store.state.current_creator_count >= $store.state.creator_max_count"
      >
        <header class="add-partner-heading">
          <h2>Add Creators</h2>
        </header>

        <div class="two-field">
          <div class="item">
            <label class="label">First name</label>
            <el-input
              v-model="values.first_name"
              placeholder="First name"
              :class="[errors.first_name && 'err-input']"
            ></el-input>
            <p class="error-msg" v-if="errors.first_name">{{ errors.first_name }}<svg-icon name="alert" /></p>
          </div>
          <div class="item">
            <label class="label">Last name</label>
            <el-input
              v-model="values.last_name"
              placeholder="Last name"
              :class="[errors.last_name && 'err-input']"
            ></el-input>
            <p class="error-msg" v-if="errors.last_name">{{ errors.last_name }}<svg-icon name="alert" /></p>
          </div>
        </div>

        <div class="account-type-row" v-if="!is_link_only">
          <div class="account-type-left">
            <label class="label">Account Type
              <tippy content="Select the account type for this creator">
                <svg-icon name="question-3" />
              </tippy>
            </label>
            <p class="error-msg" v-if="errors.platform_type">{{ errors.platform_type }}<svg-icon name="alert" /></p>
          </div>
          <div class="account-type-right">
            <el-select
              v-model="values.platform_type"
              placeholder="Select"
              class="account-type-select"
              :class="[errors.platform_type && 'err-input']"
              :teleported="true"
              popper-class="account-type-popper"
            >
              <el-option label="Storefront + Shortlink" value="storefront" />
              <el-option label="Shortlink" value="linkonly" />
            </el-select>
          </div>
        </div>
        
        

        <!-- tag -->
        <div class="coll-chec program-tag-box-big">
          <label class="label">Tag</label>
          <dl class="tag-line program-tag-box">
            <dd :class="['program-tag-box-dd', 'edit-program-tag-box-dd']">
              <div
                @click.stop="
                  values.tag_open = !values.tag_open;
                  values.tag_all_open = false;
                "
                class="add-tag-btn"
              >
                <svg-icon name="tag-plus" />
              </div>

              <Badage
                class="tag-item-box"
                v-for="(v, k) in values.merchant_account_tags.filter((ee, kk) => {
                  return kk < 8;
                })"
                :key="k"
                :value="v.text"
                :show_tippy="true"
              >
                <svg-icon name="close" @click.stop="handleSelectTag({ tag: v, row: values }, 'from_outside')" />
              </Badage>
              <Badage
                @click.stop="
                  values.tag_all_open = !values.tag_all_open;
                  values.tag_open = false;
                "
                v-if="values.merchant_account_tags.length - 8 > 0"
                :value="`+${values.merchant_account_tags.length - 5}`"
              ></Badage>
            </dd>
          </dl>

          <DropdownHashtag
            :tags="values.tags"
            :selected_tags="values.merchant_account_tags"
            :tag_type="'creator_tag'"
            @select-tag="selectTag"
            @closeKey="values.tag_open = false"
            :open_key="values.tag_open"
            :row="values"
            :drop_css="'top:unset;left:0px;bottom:36px'"
            :index="9999"
            :is_adding="true"
          />

          <HashtagPopup
            :tags="values.merchant_account_tags"
            :row="values"
            :open_key="values.tag_all_open"
            :drop_css="'top:unset;left:0px;bottom:36px'"
            :index="9999"
            @closeKey="values.tag_all_open = false"
            @open-cre-tag="
              values.tag_open = true;
              values.tag_all_open = false;
            "
          />
        </div>

        <div class="one-field">
          <label class="label">Account authentication</label>
          <p class="desc">
            Please provide an email and/or social handle(s) which we will use to authorize the creator's storefront.
          </p>
          <el-input
            v-model="values.email"
            placeholder="Enter a valid email"
            :class="[(errors.email || back_error_mag.email) && 'err-input']"
          >
            <template #prefix>
              <svg-icon name="email" />
              Email
            </template>
          </el-input>
          <el-input
            v-model="values.instagram_handle"
            placeholder="username"
            :class="[(errors.instagram_handle || back_error_mag.instagram_handle) && 'err-input']"
          >
            <template #prefix>
              <svg-icon name="instagram" />
              Instagram.com/
            </template>
          </el-input>
          <el-input
            v-model="values.tiktok_handle"
            placeholder="@username"
            :class="[(errors.tiktok_handle || back_error_mag.tiktok_handle) && 'err-input']"
          >
            <template #prefix>
              <svg-icon name="tiktok-pure" />
              TikTok.com/
            </template>
          </el-input>

          <p class="error-msg" v-if="errors.email || back_error_mag.email">
            {{ errors.email || back_error_mag.email }}<svg-icon name="alert" />
          </p>
          <p v-if="error_msg" v-html="error_msg" class="error-msg"></p>
          <p v-else-if="back_error_mag.tiktok_handle || back_error_mag.instagram_handle" class="error-msg">
            {{ back_error_mag.tiktok_handle || back_error_mag.instagram_handle }}<svg-icon name="alert" />
          </p>
        </div>

        <div class="btn-wrap">
          <p
            v-if="
              $store.state.user_data.merchant_account &&
              !$store.state.is_loading &&
              $store.state.current_creator_count >= $store.state.creator_max_count
            "
          >
            Creator limit reached.
            <a
              :href="`mailto:${$store.state.mail_to}?subject=${$store.state.user_data.merchant_account.merchant_display_name} - Upgrade creator limit&body=Please provide your name and contact info. A representative will contact you in 1-2 business days.`"
              target="_blank"
              >Contact us to upgrade.</a
            >
          </p>
          <Button
            :style="'border'"
            color="dark-blue"
            size="40"
            border_r="6"
            @click.native="is_show_import = true"
          >
          <svg-icon name="import" />
          Import CSV</Button>
          <Button
            type="submit"
            color="dark-blue"
            size="40"
            border_r="6"
            :is_disabled="$store.state.is_loading || $store.state.current_creator_count >= $store.state.creator_max_count"
          >Add</Button>
        </div>
      </Form>
    </div>

  </div>


  <Modal :is_show="is_show_import" class="upload-import-modal" @click-bg="closeImport">
    <div class="import-modal-content" :class="{ 'is-loading': is_uploading }">
      <header class="import-modal-header">
        <h3>Import Creators by CSV</h3>
        <div class="close-btn" @click="closeImport">
          <svg-icon name="close" />
        </div>
      </header>

      <div class="import-modal-body">
        <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
          <h3>Drop files to upload</h3>
        </div>

        <FileUpload
          v-show="!files.length"
          :extensions="'xlsx,xls,csv'"
          :accept="'.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'"
          :multiple="false"
          :directory="false"
          :create-directory="false"
          :thread="3 < 1 ? 1 : 3 > 5 ? 5 : 3"
          :drop="true"
          :add-index="false"
          v-model="files"
          ref="upload"
        >
          <div class="drop-zone">
            <SvgIcon name="upload" />
            <div class="drop-zone-text">
              <p>Drop CSV file here or <a>browse files to import</a></p>
              <span class="desc">Upload a .csv file. (Max. size: 5mb.)</span>
            </div>
          </div>
        </FileUpload>

        <div class="file-list" v-if="files.length">
          <div class="file-item">
            <div class="file-ico">
              <img src="@/assets/images/csv.png" />
            </div>
            <div class="file-name">{{ files[0].name }}</div>
            <div class="file-remove" @click="files = []">
              <SvgIcon name="close" />
            </div>
          </div>
        </div>
      </div>

      <footer class="import-modal-footer">
        <a
          class="download-template-link"
          :href="`${$DownloasUrl}/examples/creator_upload_template.xlsx`"
          download
          target="_blank"
        >
          Download template
        </a>
        <div class="import-modal-actions">
          <Button :style="'border'" color="dark-blue" size="32" border_r="6" @click.native="closeImport">Cancel</Button>
          <Button
            color="dark-blue"
            size="32"
            border_r="6"
            :is_disabled="!files.length || is_uploading"
            @click.native="uploadFile"
          >Upload and Review</Button>
        </div>
      </footer>
    </div>
  </Modal>

  <Modal :is_show="is_show_progress" class="progress-modal">
    <div class="box" v-if="files.length !== 0">
      <p v-if="is_file_error"><span class="error-text" v-html="file_error_msg"></span></p>
      <div class="btn" v-if="is_file_error">
        <Button type="button" :style="'border'" color="dark-blue" size="32" @click.native="cancelUpload"
          >Close</Button
        >
      </div>
      <p v-else-if="Number(progress) === 100">
        <strong>Creator data imported.</strong>
        <br />
        Click "Done" below to review information and confirm.
      </p>
      <p v-else>
        <strong>Processing creator data...</strong>
        <br />
        Please do not close this window.
      </p>
      <div v-for="(file, index) in files" :key="file.id" v-if="!is_file_error">
        <div class="progress">
          <div
            :class="{
              'progress-bar': true,
              'progress-bar-striped': true,
              'bg-danger': file.error,
              'progress-bar-animated': file.active,
            }"
            role="progressbar"
            :style="{ width: progress + '%' }"
          ></div>
        </div>

        <div class="btn">
          <span class="text">{{ progress }}%</span>
          <Button v-if="Number(progress) === 100" type="button" color="dark-blue" size="32" @click="doneUpload"
            >Done</Button
          >
          <Button v-else type="button" :style="'border'" color="dark-blue" size="32" @click.native="cancelUpload"
            >Cancel</Button
          >
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import FileUpload from 'vue-upload-component';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import formatBytes from '@/utils/formatBytes';
import Button from '@/components/ui/Button.vue';
import Modal from '@/components/ui/Modal.vue';
import Badage from '@/components/ui/Badage.vue';
import HashtagPopup from '@/components/HashtagPopup.vue';
import DropdownHashtag from '@/components/DropdownHashtag.vue';
import { getTags, handleCreTag, selectTag } from '@/utils/CreatorTagFun';
import { ElInput, ElSelect, ElOption } from 'element-plus';

import * as yup from 'yup';

export default {
  name: 'add-partner',

  components: {
    SvgIcon,
    FileUpload,
    Field,
    Button,
    Form,
    Modal,
    Badage,
    DropdownHashtag,
    HashtagPopup,
    ElInput,
    ElSelect,
    ElOption,
  },

  computed: {
    is_link_only() {
      return this.$store.state.user_data?.merchant_account?.platform_type === 'linkonly';
    },
  },

  data() {
    return {
      is_loading: false,
      is_error: false,
      interval: null,
      progress: 0,
      error_msg: '',
      is_file_error: false,
      file_error_msg: '',
      upload_data: {},

      values: {
        first_name: '',
        last_name: '',
        platform_type: '',
        tiktok_handle: '',
        instagram_handle: '',
        email: '',
        merchant_account_tags: [],
        tags: [],
        tag_open: false,
        tag_all_open: false,
      },

      schema: yup
        .object()
        .shape({
          first_name: yup.string().required('Cannot leave blank.'),
          last_name: yup.string().required('Cannot leave blank.'),
          platform_type: yup.string().required('Account type cannot be blank'),
          email: yup
            .string()
            .test(
              'is-valid-email',
              'Invalid email address.',
              (value) => !value || /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,}$/.test(value)
            )
            .notRequired(),
          instagram_handle: yup
            .string()
            .max(30, "Your handle can't exceed 30 characters")
            .matches(/(^$)|^[aA-zZ0-9_.]+$/, `Invalid social handle`)
            .notRequired(),
          tiktok_handle: yup
            .string()
            .max(30, "Your handle can't exceed 30 characters")
            .matches(/(^$)|^[@][aA-zZ0-9_.]+$|^[aA-zZ0-9_.]+$/, `Invalid social handle`)
            .notRequired(),
        })
        .test(
          'at-least-one',
          'You must fill at least one of email, instagram_handle, or tiktok_handle.',
          function (values) {
            const { email, instagram_handle, tiktok_handle } = values || {};
            const errors = [];

            // check if all three fields are empty
            if (!email && !instagram_handle && !tiktok_handle) {
              errors.push(
                this.createError({
                  path: 'email',
                  message: 'Cannot leave blank.',
                }),
                this.createError({
                  path: 'instagram_handle',
                  message: 'Cannot leave blank.',
                }),
                this.createError({
                  path: 'tiktok_handle',
                  message: 'Cannot leave blank.',
                })
              );
            }

            // check individual field validity if they are filled
            if (email && !this.schema.fields.email.isValidSync(email)) {
              errors.push(this.createError({ path: 'email', message: 'Invalid email address.' }));
            }
            if (instagram_handle && !this.schema.fields.instagram_handle.isValidSync(instagram_handle)) {
              errors.push(this.createError({ path: 'instagram_handle', message: 'Invalid social handle.' }));
            }
            if (tiktok_handle && !this.schema.fields.tiktok_handle.isValidSync(tiktok_handle)) {
              errors.push(this.createError({ path: 'tiktok_handle', message: 'Invalid social handle.' }));
            }

            // 如果有任何错误，则抛出
            if (errors.length) throw new yup.ValidationError(errors);

            return true; // 验证通过
          }
        ),
      files: [],
      is_show_progress: false,
      is_show_import: false,
      is_uploading: false,
      all_tags: [],
      tag_remove_modal: false,
      handle_remove_tag_value: {
        // to get unselected tag and row info when click the close icon on tag badge, then pass the info to tag remove modal
        row: null,
        tag: '',
      },
      back_error_mag: {
        email: '',
        instagram_handle: '',
        tiktok_handle: '',
      },
    };
  },

  props: {
    isInline: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    formatBytes: formatBytes,

    handleSelectTag(item) {
      this.handle_remove_tag_value.row = item.row;
      this.handle_remove_tag_value.tag = item.tag;
      this.tag_remove_modal = true;
    },

    update(obj) {
      this.is_error = false;
      this.error_msg = '';

      Object.keys(this.values).forEach((key) => {
        if (key === obj.key) {
          this.values[key] = obj.val.replace(/\s+$/, '');
          obj.el.value = this.values[key];
        }
      });
    },

    submit() {
      //console.log(this.values);
      this.values.tiktok_handle = this.values.tiktok_handle.replace('@', '');
      this.error_msg = '';
      this.back_error_mag.email = '';
      this.back_error_mag.tiktok_handle = '';
      this.back_error_mag.instagram_handle = '';

      const data = {
        total_row_count: 0,
        new_creator_count: 0,
        exist_creator_count: 0,
        error_count: 0,
        exist_creator_list: [],
        new_creator_list: [],
      };

      const { tag_all_open, tag_open, tags, merchant_account_tags, ...newValues } = this.values;

      // backend only needs the tag ids, so convert the merchant_account_tags to merchant_accounts_tag_ids before submit
      this.values.merchant_accounts_tag_ids = merchant_account_tags.map((e) => {
        return e.id;
      });

      if (this.is_link_only) {
        this.values.platform_type = 'linkonly';
      }


      console.log(newValues);
      this.is_loading = true;
      this.$ajax('/creator/create', {
        method: 'post',
        data: this.values,
      })
        .then((res) => {
          data.new_creator_count = 1;
          data.merchant_account_tags = merchant_account_tags;
          res.data.data.merchant_account_tags = merchant_account_tags;

          data.new_creator_list.push(res.data.data);
          this.$emit('add-creator', data);
          this.is_loading = false;
        })
        .catch((err) => {
          this.is_loading = false;
          // console.log(err.response.data);

          if (err && err.response && err.response.data.data) {
            this.is_error = true;
            let er = err.response.data.data.creator_duplicate_status;
            if (er.email_duplicate) {
              this.back_error_mag.email = 'This email has already been added.';
            }

            if (er.tiktok_duplicate) {
              this.back_error_mag.tiktok_handle = 'This social handle has already been added.';
            }

            if (er.instagram_duplicate) {
              this.back_error_mag.instagram_handle = 'This social handle has already been added.';
            }

            if (!er.email_duplicate && !er.tiktok_duplicate && !er.instagram_duplicate) {
              this.error_msg = err.response.data.data.message;
            }
          }
        });
    },

    frame() {
      if (this.progress >= 99) {
        window.clearInterval(this.interval);
      } else {
        this.progress++;
      }
    },

    uploadFile() {
      // console.log(this.$refs.upload, this.$refs.upload.active)
      this.is_uploading = true;
      this.is_show_progress = true;
      this.interval = window.setInterval(this.frame, 30);
      let form_data = new FormData();

      form_data.append('creator_list_file', this.files[0].file);

      this.$ajax(`/creator/import-file`, {
        method: 'post',
        data: form_data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((res) => {
          window.clearInterval(this.interval);
          this.progress = 100;
          res.data.data.new_creator_list.forEach((item) => {
            if (item.first_name === null) item.first_name = '';
            if (item.last_name === null) item.last_name = '';
            if (item.email === null) item.email = '';
            if (item.status_text === -2 || item.status_text === -3) item.status_text = 'Pending';
            if (!item.merchant_account_tags) item.merchant_account_tags = [];
          });
          this.upload_data = res.data.data;
        })
        .catch((err) => {
          console.log(err.response);
          this.is_file_error = true;
          this.file_error_msg = err.response.data && err.response.data.data ? err.response.data.data.message : '';
        });
    },

    cancelUpload() {
      this.progress = 0;
      this.is_file_error = false;
      this.file_error_msg = '';
      this.is_show_progress = false;
      this.is_uploading = false;
      this.$refs.upload.active = false;
      this.files = [];
    },

    closeImport() {
      this.is_show_import = false;
      this.files = [];
      this.is_uploading = false;
    },

    doneUpload() {
      this.is_show_list = true;
      this.is_show_progress = false;
      this.files = [];
      this.$emit('add-creator', this.upload_data);
    },

    selectTag(item, spec_text) {
      selectTag(item, spec_text, this, 'adding');
    },
  },

  async mounted() {
    let tagData = await getTags(this);
    if (tagData.data) {
      this.all_tags = tagData.orgData;
    }
    handleCreTag(this.values, this.all_tags);
  },
};
</script>
<style lang="scss">
.add-partner {
  padding: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .add-partner-heading {
    margin-bottom: 24px;

    h2 {
      font: var(--font-med-20);
      color: var(--black-90);
    }
  }

  .add-partner-container {
    display: flex;
    background-color: white;
    width: 100%;
    max-width: 1020px;
    border-radius: 12px;

    & > aside {
      width: 40%;
      position: relative;
      border-radius: 12px 0 0 12px;
      overflow: hidden;

      img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    & > .form-wrap {
      flex: 1;
    }
  }

  .disabeld-box {
    opacity: 0.5;
  }

  .form-wrap {
    width: 100%;
    padding: 36px;
    display: grid;
    gap: 8px;

    &.is-loading {
      opacity: 0.5;
      pointer-events: none;
    }

    &.is-error {
      .el-input .el-input--wrap select,
      .el-input .el-input--wrap input,
      .el-input .el-input--select select,
      .el-input .el-input--select input,
      .el-input .el-input--icon-wrap {
        border-color: var(--alert) !important;
      }

      .error-msg {
        margin: 4px 0 0;
        font-size: 12px;
        color: var(--alert);

        &::before {
          content: '*';
        }
      }
    }
    .err-input {
      border: solid 1px var(--alert) !important;
      border-radius: 6px;
    }

    .error-msg {
      margin: 4px 0 0;
      font-size: 12px;
      color: var(--alert);
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      &::before {
        content: '*';
      }

      .svg-icon {
        margin-left: 4px;
        width: 12px;
        height: 12px;
      }
    }

    .program-tag-box-big {
      position: relative;
      margin-bottom: 8px;

      label {
        &:after {
          display: none;
        }
      }
    }

    //tag css
    .add-tag-btn {
      padding: 4px;
      border: solid 1px var(--neutral);
      border-radius: 6px;
      height: 24px;
      display: flex;
      align-items: center;

      .svg-icon {
        margin: unset;
        width: 14px;
      }
    }

    .my-badges-iden {
      display: flex;
      align-items: center;
      border-radius: 6px;
      svg {
        height: 8px;
        width: 8px;
        margin-left: 6px;
      }

      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 100px;
        background: unset;
        display: unset;
        height: unset;
        padding: unset;
      }
    }

    .program-tag-box {
      border-radius: 6px;
      margin: 8px 0 0;
      display: flex;
      align-items: center;
      position: relative;

      dl {
        display: flex;
        align-items: center;
        width: 100%;
      }

      dt {
        font: var(--font-med-14);
        color: var(--black-90);
        display: flex;
        align-items: center;

        svg {
          width: 20px;
          height: 20px;
          fill: var(--black-90);
          margin-right: 6px;
        }
      }

      dd {
        padding-left: 12px;
        display: flex;
        align-items: center;

        span {
          display: inline-flex;
          height: 24px;
          border-radius: 4px;
          background-color: white;
          padding: 0 6px;
          align-items: center;
          font-size: 12px;
        }

        &.program-tag-box-dd {
          cursor: pointer;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          padding: 4px;
          gap: 6px;
          margin-left: 0px;
          flex: 1;
          background-color: var(--white);

          &.edit-program-tag-box-dd {
            border: solid 1px var(--neutral);
            border-radius: 6px;
          }

          .my-badges-iden {
            display: flex;
            align-items: center;
            border-radius: 6px;
            svg {
              height: 8px;
              width: 8px;
              margin-left: 6px;
            }

            span {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              max-width: 100px;
              background: unset;
              display: unset;
              height: unset;
              padding: unset;
            }
          }

          .add-tag-btn {
            padding: 4px;
            border: solid 1px var(--neutral);
            border-radius: 6px;
            height: 24px;
            display: flex;
            align-items: center;

            .svg-icon {
              margin: unset;
              width: 14px;
            }
          }
        }
      }
    }

    .two-field {
      display: flex;
      margin-bottom: 10px;

      .item {
        width: 50%;

        &:first-child {
          padding-right: 4px;
        }

        &:last-child {
          padding-left: 4px;
        }
      }
    }

    .label {
      font: var(--font-med-14);
      color: var(--black-90);
      display: flex;
      align-items: center;
      gap: 4px;

      .svg-icon {
        width: 14px;
        height: 14px;
        fill: var(--PB-20);
        cursor: pointer;
      }

      &:after {
        content: ' *';
        color: var(--alert);
      }
    }

    .label-sub {
      font: var(--font-med-14);
      color: var(--black-90);
    }

    .desc {
      font-size: 12px;
      color: var(--black-75);
      margin-bottom: 8px;
    }

    .account-type-row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 10px;

      .account-type-left {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .error-msg {
          margin: 4px 0 0;
        }
      }

      .account-type-right {
        width: 50%;
        display: flex;
        justify-content: flex-end;
      }

      .account-type-select {
        width: 100%;

        .el-input__wrapper {
          box-shadow: none;
          border: 1px solid var(--neutral);
          border-radius: 6px;
          padding: 0 12px;
          height: 40px;
        }

        &.err-input .el-input__wrapper {
          border-color: var(--alert) !important;
        }

        .el-input__inner {
          font: var(--font-fg-14);
          color: var(--black-90);
        }
      }
    }

    .el-input {
      margin: 8px 0 0;
    }

    .el-input__wrapper {
      padding-left: 1px;
    }

    .el-input__prefix-inner {
      color: var(--black-90);
      padding: 0 10px;
      background-color: var(--bg-02);
      border-radius: 6px 0 0 6px;
      border-right: 1px solid var(--neutral);
      display: flex;
      align-items: center;

      svg {
        height: 14px;
        width: 14px;
      }
    }

    .el-input__inner {
      padding-left: 10px;
    }

    .el-input--icon-wrap .befter-icon {
      margin-left: 10px;
    }

    .el-input--icon-wrap input,
    .el-input--wrap input {
      padding: 12px 10px;
    }

    .el-input--icon-wrap .befter-text + input {
      padding-left: 0;
    }

    .btn-wrap {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 16px;
      gap: 16px;

      p {
        flex: 1;
        font-size: 12px;
        display: flex;
        align-items: center;

        a {
          text-decoration: underline;
          margin-left: 5px;

          &:hover {
            text-decoration: none;
          }
        }
      }

      .ui-button {
        text-align: center;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        min-width: 120px;

        svg {
          height: 18px;
          width: 18px;
        }
      }
    }
  }
}


.upload-import-modal {
  .ui-modal--container {
    width: 580px;
  }

  .import-modal-content {
    padding: 24px;

    &.is-loading {
      .import-modal-body {
        opacity: 0.5;
        pointer-events: none;
      }

      .import-modal-footer .import-modal-actions .ui-button:last-child {
        opacity: 0.5;
        pointer-events: none;
      }
    }
  }

  .import-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    h3 {
      font: var(--font-med-18);
      color: var(--black-90);
    }

    .close-btn {
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 4px;

      &:hover {
        background-color: var(--black-10);
      }

      svg {
        width: 12px;
        height: 12px;
        fill: var(--black-60);
      }
    }
  }

  .import-modal-body {
    .drop-active {
      position: fixed;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(#000, 0.65);
      color: var(--black-10);
      z-index: 99999999999999;

      h3 {
        font: var(--font-fg-18);
      }
    }

    .file-uploads {
      display: block;
      cursor: pointer;
      width: 100%;

      & > label {
        cursor: pointer;
        width: 100%;
      }
    }

    .drop-zone {
      border: 1px dashed var(--black-20);
      border-radius: 8px;
      padding: 32px 24px;
      background-color: var(--Bg-01);
      display: flex;
      align-items: center;
      gap: 16px;
      cursor: pointer;
      transition: border-color 0.2s;

      &:hover {
        border-color: var(--blue);
      }

      svg {
        width: 40px;
        height: 40px;
        fill: var(--black-40);
        flex-shrink: 0;
      }

      .drop-zone-text {
        text-align: left;

        p {
          font: var(--font-fg-14);
          color: var(--black-90);
          margin: 0;

          a {
            color: var(--blue);
            text-decoration: underline;
            cursor: pointer;

            &:hover {
              text-decoration: none;
            }
          }
        }

        .desc {
          font-size: 12px;
          color: var(--black-50);
          margin-top: 4px;
          display: block;
        }
      }
    }

    .file-list {
      border: 1px solid var(--black-20);
      border-radius: 8px;
      overflow: hidden;

      .file-item {
        display: flex;
        align-items: center;
        padding: 16px;
        gap: 12px;

        .file-ico {
          width: 72px;
          height: 72px;
          flex-shrink: 0;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .file-name {
          flex: 1;
          font: var(--font-fg-14);
          color: var(--black-90);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .file-remove {
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border: 1px solid var(--black-20);
          border-radius: 4px;
          flex-shrink: 0;

          &:hover {
            background-color: var(--black-10);
          }

          svg {
            width: 12px;
            height: 12px;
            fill: var(--black-60);
          }
        }
      }
    }
  }

  .import-modal-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;

    .download-template-link {
      font: var(--font-fg-14);
      color: var(--blue);
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }

    .import-modal-actions {
      display: flex;
      align-items: center;
      gap: 12px;

      .ui-button {
        min-width: 100px;
        text-align: center;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.account-type-popper {
  z-index: 10000 !important;
}

.progress-modal {
  .ui-modal--container {
    width: 460px;
  }

  .box {
    padding: 24px 32px 32px;

    p {
      margin: 0 0 14px;

      strong {
        font-weight: 600;
      }

      // & + div {
      //     height: 8px;
      // }
    }

    .progress {
      height: 8px;
      background-color: var(--black-10);
      position: relative;

      .progress-bar {
        height: 100%;
        position: absolute;
        left: 0;
        background-color: var(--dark-blue);
        transition: 0.1s width ease;
      }
    }

    .error-text {
      color: var(--alert);
    }

    .btn {
      display: flex;
      align-items: center;
      margin-top: 16px;
      font: var(--font-fg-14);

      .text {
        flex: 1;
        color: var(--dark-blue);
      }

      .ui-button {
        width: 180px;
        text-align: center;
      }
    }
  }
}
</style>
